module.exports = __webpack_public_path__ + "img/head.22c1e654.svg";